export enum AllocatedToEntityType {
    user = 0,
    team = 1
}